module.exports = __webpack_public_path__ + "img/prop-tv-1-right.1bb48231.png";